import React from 'react';
import PropTypes from 'prop-types';

import styles from './SelectFile.module.css';

const SelectFile = ({ file, disabled, error, onSelect, clear }) => (
  <div
    className={`${styles.container}
    ${disabled ? styles.disabled : ''}
    ${error ? styles.error : ''}`}
  >
    <div className={styles.file}>
      {file && (
        <>
          <div>{file.name}</div>
          <button type="button" className={styles.closeFile} onClick={clear}>
            <i className="fal fa-times" />
          </button>
        </>
      )}
    </div>
    <label className={styles.browse} htmlFor="file">
      <input id="file" type="file" accept=".csv" value="" onChange={onSelect} />
      Browse
    </label>
  </div>
);

SelectFile.propTypes = {
  file: PropTypes.shape({
    name: PropTypes.string,
  }),
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  clear: PropTypes.func.isRequired,
};

SelectFile.defaultProps = {
  file: null,
  disabled: false,
  error: false,
};

export default SelectFile;
